import { useEffect, useMemo, useState } from 'react';
import { OrganisationModel } from 'shared/types/Organisation';

import { useDBSyncContext } from '@/context/DBSyncContext';
import { useDatabase } from '@/hooks';

export function useOrganisationData() {
    const { getDatabase } = useDatabase();
    const { isInitialSyncInProgress } = useDBSyncContext();

    const database = useMemo(() => getDatabase(), [getDatabase]);

    const [organisation, setOrganisation] = useState<OrganisationModel | null>(
        null,
    );
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        if (isInitialSyncInProgress) {
            return;
        }

        const subscription = database.collections
            .get<OrganisationModel>('organisations')
            .query()
            .observeWithColumns([
                'alternative_address',
                'payment_instructions',
                'footer_message',
                'alternative_email',
                'alternative_phone_number',
                'alternative_phone_prefix',
                'is_alternative_email_enabled',
                'is_alternative_phone_enabled',
                'tax_rate',
                'products_tax_rate',
            ])
            .subscribe(([org]) => {
                setOrganisation(org ?? null);
                setIsLoading(false);
            });

        return () => subscription.unsubscribe();
    }, [database, isInitialSyncInProgress]);

    return { organisation, isLoading };
}
